import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate , ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//import { JwtHelper }      from 'angular2-jwt';
import { JwtHelperService } from "@auth0/angular-jwt";
import * as CryptoJS      from 'crypto-js';

@Injectable()
export class OrgAuthGuardService implements CanActivate {

  constructor(private router: Router, private jwtHelperService: JwtHelperService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {//alert('CanActivate')
    try{
      //console.log('AuthGuard: checking onreference_org');
      const raw = sessionStorage.getItem('onreference_org');
      //console.log('AuthGuard: raw session:', raw ? 'exists' : 'NULL');

      if (!raw) {
        this.redirectToLogin(state);
        return false;
      }

      const decoded = this.b64DecodeUnicode(raw);
      const user = decoded ? JSON.parse(decoded) : null;

      //console.log('AuthGuard: user:', user ? 'exists' : 'NULL');
      //console.log('AuthGuard: id_token:', user?.id_token ? 'exists' : 'NULL');
      //console.log('AuthGuard: token expired:',
        //user?.id_token ? this.jwtHelperService.isTokenExpired(user.id_token, 15) : 'N/A');

      if (!user || !user.id_token || this.jwtHelperService.isTokenExpired(user.id_token, 15)) {
        this.resetSessionStorage();
        this.redirectToLogin(state);
        return false;
      }

      return true;
      
    }catch(e){
      console.error('AuthGuard error:', e);
      this.resetSessionStorage();
      this.redirectToLogin(state);
      return false;
    }
  }

  private redirectToLogin(state: RouterStateSnapshot) {
    console.trace('AUTHGUARD navigate to org-login');
    this.router.navigate(['/org-login'], { queryParams: { returnUrl: state.url } });
  }
   private resetSessionStorage(){
    try{
          sessionStorage.removeItem('onreference_org');
          sessionStorage.removeItem('onreference_orgref');          

          sessionStorage.removeItem('onreference_ent');
          sessionStorage.removeItem('onreference_entref');

          sessionStorage.removeItem('onreference_adm');

          sessionStorage.removeItem('onreference_entpts');
          sessionStorage.removeItem('onreference_orgpts');   
          
          sessionStorage.removeItem('onreference_reuse_ind-home');
          sessionStorage.removeItem('onreference_reuse_org-home');          
          
    }catch(e) {
            return false;
    }
    return true;
 }

    private b64EncodeUnicode(str: string) {
     var words = CryptoJS.enc.Utf8.parse(str);
     return CryptoJS.enc.Base64.stringify(words)
  }

   /*public b64DecodeUnicode(base64) {
    if (base64 === null){ return null};
    var words = CryptoJS.enc.Base64.parse(base64);
    return CryptoJS.enc.Utf8.stringify(words);
  }*/
  public b64DecodeUnicode(base64: string) {
    try {
      if (!base64) return null;
      const words = CryptoJS.enc.Base64.parse(base64);
      return CryptoJS.enc.Utf8.stringify(words);
    } catch (e) {
      console.error('Base64 decode failed:', e);
      return null;
    }
  }

}
